<!-- eslint-disable -->
<template>
  <div class="container-login">
    <loading :active="isRecoveryPassword ? isLoadingRecoveryPassword : isLoadingLogin" />

    <div class="background-image d-flex justify-center align-center">
      <div
        v-if="!isRecoveryPassword"
        class="form-login"
      >
        <h3 class="form-header">
          Login
        </h3>

        <span class="form-subheader">
          Digite seu E-MAIL e SENHA para acessar
        </span>

        <v-text-field
          v-model="loginUser.email"
          label="E-mail"
          class="mt-2 form-input"
          hide-details="auto"
          :disabled="isLoadingLogin"
          outlined
          dense
        />

        <v-text-field
          v-model="loginUser.password"
          label="Senha"
          class="mt-2 form-input"
          hide-details="auto"
          :disabled="isLoadingLogin"
          :append-icon="showPassword ? mdiEye : mdiEyeOff"
          :type="showPassword ? 'text' : 'password'"
          outlined
          dense
          @click:append="showPassword = !showPassword"
          @keyup.enter="loginUser.email && loginUser.password ? login() : null"
        />

        <v-btn
          class="mt-2 white--text"
          :loading="isLoadingLogin"
          color="#0f505f"
          :disabled="!loginUser.email || !loginUser.password"
          block
          rounded
          @click="login()"
        >
          Acessar
        </v-btn>
        <br>
        <v-container
          class="py-0"
          fluid
        >
          <v-row class="container-buttons">
            <!-- TODO(vignatti): this checkbox has no action at the moment -->
            <v-checkbox
              v-model="savePassword"
              class="save-password"
              label="Memorizar a senha?"
              hide-details
            />

            <span
              class="recovery-password"
              @click="swapLoginAndRecoveryPassword()"
            >
              Esqueci minha senha
            </span>
          </v-row>
        </v-container>
      </div>
      <div
        v-if="isRecoveryPassword"
        class="form-recovery-password"
      >
        <h3 class="form-header">
          Recuperar senha
        </h3>

        <span class="form-subheader">
          Informe seu E-MAIL, caso esteja cadastrado você receberá instruções para recuperar sua senha
        </span>

        <v-text-field
          v-model="emailRecoveryPassword"
          label="E-mail cadastrado"
          hide-details="auto"
          class="mt-6 form-input"
          outlined
          dense
          @keyup.enter="emailRecoveryPassword ? recoveryPassword() : null"
        />

        <v-btn
          class="mt-6 white--text"
          color="#0f505f"
          :loading="isLoadingRecoveryPassword"
          :disabled="!emailRecoveryPassword"
          rounded
          block
          @click="recoveryPassword()"
        >
          Enviar
        </v-btn>

        <v-row class="container-buttons justify-center align-center pt-4">
          <span
            class="recovery-password mt-1"
            @click="redirectTologin()"
          >
            Realizar login
          </span>
        </v-row>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions } from 'vuex'
import { mdiClose, mdiEye, mdiEyeOff } from '@mdi/js'
import Vue from 'vue'
import firebase from '@/api/firebase'

export default {
  name: 'Login',
  data () {
    return {
      emailRecoveryPassword: '',
      isLoadingLogin: false,
      isLoadingRecoveryPassword: false,
      active_tab: 0,
      isRecoveryPassword: false,
      showPassword: false,
      savePassword: false,
      toastText: '',
      toastOptions: {
        position: 'bottom-center',
        duration: 3000
      },
      loginUser: {
        user: '',
        password: '',
        email: ''
      },
      user: {
        displayName: '',
        email: ''
      },
      mdiClose, mdiEye, mdiEyeOff
    }
  },
  methods: {
    async login () {
      let vm = this

      if (this.loginUser.email === 'democatalogo@imersys.com' || this.loginUser.email === 'democatalogo') {
        vm.toastText = 'Usuário "democatalogo" não está mais disponível. Envie um email para contato@imersys.com para iniciar sua inscrição gratuita!'

        this.$toasted.show(this.toastText, {
          position: 'bottom-center',
          type: 'success',
          duration: 10000
        })
        return
      }
      this.isLoadingLogin = true

      await this.$auth.signInWithEmailAndPassword(this.loginUser.email, this.loginUser.password)
        .then(async result => {
          this.isLoadingLogin = false

          vm.user = result.user

          // This is due migration purposes for the new auth mechanism. The old
          // auth mechanism required users to type their e-mail for login,
          // which would not save displayName field internally in Firestore. We
          // need to workaround this therefore.
          if (!vm.user.displayName) {
            vm.user.displayName = vm.loginUser.user
          }

          let localUser = {
            displayName: vm.user.displayName,
            email: vm.user.email
          }

          this.createGoogleAnalyticsData()

          localStorage.setItem('user', JSON.stringify(localUser))
          this.$router.push({ name: 'ContentHome' })
        })
        .catch(err => {
          this.isLoadingLogin = false

          // Handle Errors here.
          var errorCode = err.code
          var errorMessage = err.message

          if (errorCode === 'auth/wrong-password') {
            vm.toastText = 'Senha inválida.'
          } else {
            vm.toastText = errorMessage
          }

          this.$toasted.show(this.toastText, {
            position: 'bottom-center',
            type: 'error',
            duration: 3000
          })
        })
    },

    recoveryPassword () {
      if (this.emailRecoveryPassword === 'democatalogo@imersys.com') {
        this.toastText = 'Usuário "democatalogo" não está mais disponível. Envie um email para contato@imersys.com para iniciar sua inscrição gratuita!'

        this.$toasted.show(this.toastText, {
          position: 'bottom-center',
          type: 'success',
          duration: 10000
        })
        return
      }

      this.isLoadingRecoveryPassword = true

      this.$auth.sendPasswordResetEmail(this.emailRecoveryPassword)
        .then(() => {
          this.isLoadingRecoveryPassword = false

          this.cleanFieldsRecoveryPassword()

          let text = 'Em breve uma nova senha será enviada em seu e-mail cadastrado.'
          this.$toasted.show(text, this.toastOptions)
        })
        .catch(err => {
          let errorMessage = err.message
          if (err.code === 'auth/invalid-email') {
            errorMessage = 'Formato incorreto de endereço de e-mail.'
          } else if (err.code === 'auth/user-not-found') {
            errorMessage = 'Usuário correspondente a este endereço não foi encontrado. O usuário possivelmente foi removido.'
          }

          this.$toasted.show(errorMessage, this.toastOptions)

          this.isLoadingRecoveryPassword = false
        })
    },

    redirectTologin () {
      this.isRecoveryPassword = !this.isRecoveryPassword
      this.cleanFieldsRecoveryPassword()
    },

    cleanFieldsRecoveryPassword () {
      this.isOpenModalRecoveryPassword = false
      this.emailRecoveryPassword = ''
      this.usersRecoveryPassword = []
    },

    swapLoginAndRecoveryPassword () {
      this.isRecoveryPassword = !this.isRecoveryPassword
      this.isLoadingLogin = false
      this.isLoadingRecoveryPassword = false
    },
    async getInstitution() {
      let params = {
        'userEmail': this.loginUser.email
      }
      let institution
      let data = await firebase.getUserByEmail(params)
      await data.forEach(doc => {
        institution = doc.data().institution
      })
      return institution
    },
    async createGoogleAnalyticsData() {
      let institution = await this.getInstitution()

      this.$gtag.event('login',{
        'event_category': 'User engagement',
        'event_label': 'Institution engagement',
        'institution': institution
      })

      this.$gtag.set('user_properties',{
        'institution': institution,
      })

    },
  }
}
</script>
<style lang="scss" scoped>
div.container-login {
  height: 100%;
  div.background-image {
    height: calc(100% - 140px);
    padding: 0;
    background: url("../../assets/imgs/logo_ambia.png") center 100% no-repeat;
    position: relative;

    div.form-login,
    .form-recovery-password {
      width: 400px;
      text-align: center;
      border-radius: 10px;
      position: absolute;
      padding: 5px 10px;
      @media all and (max-width: 768px) {
        width: 300px;
      }

      h3.form-header {
        font-weight: bold;
      }

      span.form-subheader {
        font-size: 14px;
        @media all and (min-width: 1020px) {
          font-size: 15px;
        }
        @media all and (max-width: 768px) {
          font-size: 12px;
        }
      }

      div.form-input .v-label {
        font-weight: bold;
      }

      div.form-input {
        @media all and (max-width: 768px) {
          margin-top: 10px !important;
        }
      }

      div.container-buttons {
        display: flex;
        justify-content: space-between;
        align-items: center;
        @media all and (max-width: 768px) {
          justify-content: center;
        }

        .save-password {
          margin-top: 10px !important;
        }

        .recovery-password {
          cursor: pointer;
          text-decoration: underline;
          margin-top: 10px !important;
          @media all and (max-width: 768px) {
            margin-top: 10px;
          }
        }
      }

      button span.v-btn__content {
        color: white;
        text-transform: capitalize;
      }
    }
  }
}
</style>
